import { render } from "./SelectSearchWithLabel.vue?vue&type=template&id=10f904f6"
import script from "./SelectSearchWithLabel.vue?vue&type=script&lang=js"
export * from "./SelectSearchWithLabel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__